export { InfoModal } from './Info';
